import React from 'react';
import './popup.scss';

const PopupOneButton = ({
  title,
  description,
  buttonText,
  padding,
  onClick,
  closeModal,
  onKeyUp,
  isKeyPressed,
}) => {
  const customPadding = { padding: padding };
  function pressKey(event) {
    if (event.key === 'Enter' && !isKeyPressed) {
      closeModal();
    }
  }
  return (
    <div onKeyUp={onKeyUp} role="alert">
      <div className="modal-top-bar">
        {closeModal && (
          <div
            aria-label="Close button"
            className="close-modal"
            id="close-modal"
            onClick={closeModal}
            onKeyUp={pressKey}
            role="button"
            tabIndex="0"
          ></div>
        )}
      </div>{' '}
      <div className="popup-one-button" style={customPadding}>
        <h1 className="popup-title">{title}</h1>
        <p className="description">{description}</p>
        <div className="button-container">
          <button
            className="button-primary-modal"
            id="button-primary-modal"
            onClick={onClick}
            autoFocus
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupOneButton;
